var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":"12","md":"11"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }